module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/1/3-5342a47202d053f78f1725baa3d80255.jpg";